import type { TaskCard } from "../types";

export type NudgeKind = "soon" | "now" | "overdue";
export type Nudge = { task: TaskCard; kind: NudgeKind; key: string };

const SOON_MS = 10 * 60_000;

/**
 * Which open tasks deserve a corner pop-up now: due within 10 minutes, due
 * now, or overdue (today). Each task/due/kind pops once: `seen` holds the keys.
 * Overdue tasks from earlier days do not pop: the tasks page shows them.
 */
export const taskNudges = (
  tasks: TaskCard[],
  now: Date,
  seen: Set<string>,
): Nudge[] => {
  const nudges: Nudge[] = [];
  for (const task of tasks) {
    if (task.done_date || !task.due_date) continue;
    const due = new Date(task.due_date).getTime();
    const left = due - now.getTime();
    const kind: NudgeKind | null =
      left > 0 && left <= SOON_MS
        ? "soon"
        : left <= 0 && left > -2 * 60_000
          ? "now"
          : left <= -2 * 60_000 &&
              new Date(due).toDateString() === now.toDateString()
            ? "overdue"
            : null;
    if (!kind) continue;
    const key = `${task.id}:${task.due_date}:${kind}`;
    if (seen.has(key)) continue;
    nudges.push({ task, kind, key });
  }
  return nudges;
};
